/**
 * @generated SignedSource<<f442fbbb9782e85dfb1b2943ef64e21c>>
 * @relayHash 6dbdbe4a62543b90fa6c0a2b3bb68c6f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceTrackSourceInput = "MOBILE" | "WEB" | "%future added value";
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type ConfluenceReorderTrackInput = {
  referenceTrack?: ConfluenceTrackInput | null | undefined;
  targetTrack: ConfluenceTrackInput;
};
export type ConfluenceTrackInput = {
  mainSource: string;
  supportingSources?: ReadonlyArray<string> | null | undefined;
  trackSource?: ConfluenceTrackSourceInput | null | undefined;
  trackType: ConfluenceTrackType;
};
export type useContextMenuActionsReorderTrackMutation$variables = {
  cloudId: string;
  input: ConfluenceReorderTrackInput;
};
export type useContextMenuActionsReorderTrackMutation$data = {
  readonly confluence_reorderTracks: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useContextMenuActionsReorderTrackMutation = {
  response: useContextMenuActionsReorderTrackMutation$data;
  variables: useContextMenuActionsReorderTrackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceReorderTrackPayload",
    "kind": "LinkedField",
    "name": "confluence_reorderTracks",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "ConfluenceReorderTrackPayloadError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          },
          {
            "concreteType": "ConfluenceReorderTrackPayloadErrorExtension",
            "kind": "LinkedField",
            "name": "extensions",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "statusCode"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useContextMenuActionsReorderTrackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useContextMenuActionsReorderTrackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "08d80dad1041c3f20d85c84d8afb8c5ec82779d04c25add523b3c8f265d56e74",
    "metadata": {},
    "name": "useContextMenuActionsReorderTrackMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5739afa9f8b36d85167f2ad0033521ff";

export default node;
